import type { ApiResponse } from '@/shared/types';
import type { FeedbackSubjectOption } from '@/shared/types/feedback';
import api from '@/shared/api/client';

export const operatorFeedbackApi = {
  getUserFeedbacksUnreadCount: () =>
    api.get<ApiResponse<{ count: number }>>(
      '/operator/user-feedbacks/unread-count',
    ),

  listSubjects: () =>
    api.get<ApiResponse<FeedbackSubjectOption[]>>('/operator/user-feedbacks/subjects'),

  listUserFeedbacks: (params?: Record<string, any>) =>
    api.get<ApiResponse<any>>('/operator/user-feedbacks', { params }),

  getUserFeedback: (id: string) =>
    api.get<ApiResponse<any>>(`/operator/user-feedbacks/${id}`),

  updateUserFeedbackStatus: (id: string, status: string) =>
    api.patch<ApiResponse<any>>(`/operator/user-feedbacks/${id}/status`, {
      status,
    }),

  replyUserFeedback: (
    id: string,
    data: { content: string; attachments?: any[] },
  ) => api.post<ApiResponse<any>>(`/operator/user-feedbacks/${id}/reply`, data),

  markUserFeedbackRead: (id: string) =>
    api.post<ApiResponse<any>>(`/operator/user-feedbacks/${id}/read`),

  presignUserFeedbackAttachment: (
    id: string,
    data: { fileName: string; mimeType: string; fileSize: number },
  ) =>
    api.post<ApiResponse<{ uploadUrl: string; storageKey: string }>>(
      `/operator/user-feedbacks/${id}/attachments/presign`,
      data,
    ),
};
